/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptAnalyticsSortCriteria {
    getFixupPrototypeFunction() { return PromptAnalyticsSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<PromptAnalyticsSortCriteria>): PromptAnalyticsSortCriteria {
        let obj = Object.assign(new PromptAnalyticsSortCriteria(), model);
        PromptAnalyticsSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptAnalyticsSortCriteria>): PromptAnalyticsSortCriteria {
        if (!model) return null;
        return PromptAnalyticsSortCriteria.newInstance(<PromptAnalyticsSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptAnalyticsSortCriteria) {
        if (!obj) return;

        models.PromptAnalyticsSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptAnalyticsSortCriteria): boolean {
        Object.setPrototypeOf(obj, PromptAnalyticsSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.PromptAnalyticsSortColumn;

    ascending: boolean;

}
